import { isCanvasModule } from '@/modules/common/helpers/navigation';
import { PropertyPanel as SalesPropertyPanel } from '@/modules/salesWorkspace';
import { useAppStore } from '@/modules/app/store/useAppStore';

export function PropertiesPanelContent() {
  const activeModule = useAppStore((state) => state.activeModule);

  return isCanvasModule(activeModule) ? <SalesPropertyPanel /> : null;
}
